import { FC } from 'react';

const NotionIframe: FC<{ uri?: string }> = ({ uri }) => {
  if (!uri) return null;
  const src = decodeURIComponent(uri);
  return <iframe src={src} style={{ flex: 1, width: '100%', border: 'none' }} />;
};

export default NotionIframe;
